import React, { Dispatch, FC, SetStateAction, useEffect, useMemo } from 'react'
import {
  BoAdvisorContainer,
  BsoClientContainer,
  MeetingConfirmationContainer,
  MeetingScheduleContainer,
} from 'pages/Owner/container'
import { MEETING_STEPPER } from 'config'
import { ISelectedClient } from 'components/Calendar/MeetingSchedule'
import { UserProfile } from '__generated__/api-types-and-hooks'

const DEFAULT_MEETING_DURATION = 60

interface IScheduleMeetingModalBoxProps {
  setSelectedAdvisorLink?: (params) => void
  selectedAdvisorId: null | string
  setSelectedAdvisorId: Dispatch<SetStateAction<null | string>>
  meetingStepper: MEETING_STEPPER
  setShowModalBox: (e: boolean) => void
  selectedClient?: ISelectedClient | null
  setSelectedClient?: (client?: ISelectedClient | null) => void
  isBSOUser?: boolean
  selectedDuration?: number
  setSelectedDuration?: (duration: number) => void
  boAdvisors: UserProfile[]
  errorMessage: string
  isSuccess: boolean
  updateMeetingStepperAction: (params: { actionType: string; stepName: string }) => void
  getUserAvailabilityActionReset: () => void
}

const ScheduleMeetingModalBox: FC<IScheduleMeetingModalBoxProps> = ({
  setSelectedAdvisorLink = (e) => {},
  selectedAdvisorId,
  setSelectedAdvisorId,
  meetingStepper,
  setShowModalBox = (e: boolean) => {},
  selectedClient,
  setSelectedClient = (e) => {},
  isBSOUser = false,
  selectedDuration = DEFAULT_MEETING_DURATION,
  setSelectedDuration = (e) => {},
  boAdvisors,
  errorMessage,
  updateMeetingStepperAction,
  isSuccess,
  getUserAvailabilityActionReset,
}) => {
  const selectedAdvisor = useMemo(() => {
    return boAdvisors.find((advisor) => advisor.id === selectedAdvisorId)
  }, [boAdvisors, selectedAdvisorId])

  const handleClose = () => {
    updateMeetingStepperAction({
      actionType: 'reset',
      stepName: MEETING_STEPPER.ADVISOR,
    })
    if (!errorMessage) {
      setShowModalBox(false)
    }
  }
  const error = errorMessage
    ? `We were unable to create the meeting with ${selectedAdvisor?.firstName}
  ${selectedAdvisor?.lastName}. It’s probably us, not you!`
    : ''

  const successMessage = !error
    ? `${selectedAdvisor?.firstName} ${selectedAdvisor?.lastName} has received a new meeting notification that includes all of the meeting details.`
    : ''

  useEffect(() => {
    if (meetingStepper === MEETING_STEPPER.ADVISOR) {
      getUserAvailabilityActionReset()
    }
    // eslint-disable-next-line
  }, [meetingStepper])
  return (
    <React.Fragment>
      {meetingStepper === MEETING_STEPPER.ADVISOR ? (
        <div>
          {isBSOUser ? (
            <BsoClientContainer
              setSelectedClient={setSelectedClient}
              selectedClient={selectedClient}
              setSelectedDuration={setSelectedDuration}
              selectedDuration={selectedDuration}
              setShowModalBox={setShowModalBox}
            />
          ) : (
            <BoAdvisorContainer
              onSelect={(value) => {
                setSelectedAdvisorLink(value)
              }}
              setSelectedAdvisorId={setSelectedAdvisorId}
              selectedAdvisorId={selectedAdvisorId || ''}
              setSelectedDuration={setSelectedDuration}
              selectedDuration={selectedDuration}
            />
          )}
        </div>
      ) : (
        <MeetingScheduleContainer
          meetingStepper={meetingStepper}
          selectedAdvisorId={selectedAdvisorId}
          setShowModalBox={setShowModalBox}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          selectedDuration={selectedDuration}
        />
      )}

      {meetingStepper === MEETING_STEPPER.MEETING_CONFIRMATION && selectedAdvisor && (
        <MeetingConfirmationContainer
          labelText=""
          handleClose={handleClose}
          errorMessage={error}
          successMessage={successMessage}
        />
      )}
    </React.Fragment>
  )
}

export default ScheduleMeetingModalBox
